<template>
  <div class="bigBox">
    <div class="bgcBox"></div>
    <Header class="headBox" :color="'#fff'" />
    <h5>{{ registerTitle[stepStatue] }}</h5>
    <canvas id="canvas" style="display: none"></canvas>
    <!-- <Stepbar /> -->
    <div class="stepBox">
      <img v-if="stepStatue == 1" src="../assets/images/step1.png" alt="" />
      <img v-if="stepStatue == 2" src="../assets/images/step2.png" alt="" />
      <img v-if="stepStatue == 3" src="../assets/images/step3.png" alt="" />
      <img v-if="stepStatue == 4" src="../assets/images/step4.png" alt="" />
    </div>
    <van-collapse v-model="activeNames" accordion>
      <!-- first Step -->
      <van-collapse-item
        title="Información simple y básica"
        name="1"
        v-loading="loading1"
      >
        <!-- position choose -->
        <div
          class="chooseListBox"
          v-for="item in cascaderArray"
          @click="openChoosCascader()"
          :key="item.id"
        >
          <p class="title">{{ item.title }}</p>
          <p class="content">
            {{ item.text || "" }}
          </p>
          <van-icon name="arrow" />
        </div>
        <!-- wageGradeList -->
        <div
          class="chooseListBox"
          @click="openChoosVisible(1, 'Nivel de ingresos')"
        >
          <p class="title">Nivel de ingresos</p>
          <p class="content">
            {{ dataInfoText.monthly_income }}
          </p>
          <van-icon name="arrow" />
        </div>
        <!-- getEduList -->
        <div
          class="chooseListBox"
          @click="openChoosVisible(2, 'Información Académica')"
        >
          <p class="title">Información Académica</p>
          <p class="content">
            {{ dataInfoText.education }}
          </p>
          <van-icon name="arrow" />
        </div>
        <!-- email -->
        <div
          class="emailSelet"
          :style="{ height: showEmailList ? '3.5rem' : '0.7rem' }"
        >
          <van-field
            label="Correo electrónico"
            @input="changeEmail"
            @blur="closeSelect"
            v-model="dataInfoList.email"
            placeholder=""
          />
          <div
            :style="{ height: showEmailList ? '2.7rem' : '0' }"
            class="selectBox"
          >
            <ul>
              <li
                v-for="(item, index) in emailShowList"
                :key="index"
                @click="chooseEmail(item)"
              >
                {{ item }}
              </li>
            </ul>
          </div>
        </div>
        <div class="submitBtn" @click="submitBtn(1)">
          Entregar
        </div>
      </van-collapse-item>

      <!-- second Step -->
      <van-collapse-item
        title="Información del contacto"
        name="2"
        id="disBtn2"
        :disabled="stepStatue >= 2 ? false : true"
        v-loading="loading2"
      >
        <ul class="concatBox">
          <!-- contact 1 -->
          <li v-for="(item, index) in dataContactInfoArray" :key="index">
            <h5>{{ "Contacto" + (index + 1) }}</h5>
            <!-- choose relation Box -->
            <div
              class="chooseListBox"
              @click="openChoosVisible(item.id, 'Relación')"
            >
              <p
                class="content"
                :style="{
                  color: item.relationshipText ? '#333' : '#B8B9BA',
                }"
              >
                {{ item.relationshipText || "Relación" }}
              </p>
              <van-icon name="arrow" />
            </div>
            <!-- contact 1 name -->
            <van-field
              type="digit"
              maxlength="9"
              v-model="dataContactInfo['contact' + (index + 1)]"
              placeholder="Número telefónico"
            />
            <!-- contact 1 phone -->
            <van-field
              v-model="dataContactInfo['contact' + (index + 1) + '_name']"
              placeholder="Nombre"
            />
          </li>
        </ul>
        <div class="submitBtn" @click="submitBtn(2)">
          Entregar
        </div>
      </van-collapse-item>

      <!-- third Step -->
      <van-collapse-item
        title="Información de identidad"
        name="3"
        id="disBtn3"
        :disabled="stepStatue >= 3 ? false : true"
        v-loading="loading3"
      >
        <van-uploader
          :after-read="uploadSuccess"
          v-model="fileList"
          :max-count="1"
          preview-image
        >
          <img src="../assets/images/uploadImg.png" alt="" />
        </van-uploader>
        <p class="uploadText">
          Sube el frente del documento de identidad válido!
        </p>
        <!-- id Card -->
        <van-field
          type="digit"
          maxlength="8"
          v-model="dataIdCardInfo.dni"
          placeholder="Ingresa el número de DNI de 8 dígitos"
        />
        <!-- first name -->
        <van-field
          v-model="dataIdCardInfo.surname1"
          placeholder="Primer Apellido"
        />
        <!-- second name -->
        <van-field
          v-model="dataIdCardInfo.surname2"
          placeholder="Segundo Apellido"
        />
        <!-- name -->
        <van-field v-model="dataIdCardInfo.name1" placeholder="Pre Nombre" />
        <!-- gender -->
        <h3>Género</h3>
        <el-radio-group v-model="dataIdCardInfo.gender" size="mini">
          <el-radio label="W" border>Femenino</el-radio>
          <el-radio label="M" border>Masculino</el-radio>
        </el-radio-group>
        <!-- choose Date -->
        <div class="chooseListBox" @click="openDateVisible">
          <p
            class="content"
            :style="{
              color: dataIdCardInfo.birthday ? '#333' : '#B8B9BA',
            }"
          >
            {{ birthdayText || "Fecha de nacimiento" }}
          </p>
          <van-icon name="arrow" />
        </div>
        <div class="submitBtn" @click="submitBtn(3)">
          Entregar
        </div>
      </van-collapse-item>

      <!-- fourth Step -->
      <van-collapse-item
        title="Información de la cuenta bancaria"
        name="4"
        id="disBtn4"
        :disabled="stepStatue >= 4 ? false : true"
        v-loading="loading4"
      >
        <!-- choose Bank -->
        <div class="chooseListBox" @click="openBankListVisible">
          <p
            class="content"
            :style="{
              color: dataBankInfo.bank_name ? '#333' : '#B8B9BA',
            }"
            style="width: 95%"
          >
            {{ dataBankInfo.bank_name || "Nombre de banco" }}
          </p>
          <van-icon name="arrow" />
        </div>
        <div
          v-if="nowBankInfo.bankId == '0101' || nowBankInfo.bankId == '0102'"
          class="bankTitleBox"
        >
          <van-field
            type="digit"
            maxlength="9"
            v-model="dataBankInfo.bank_no"
            :placeholder="
              'Ingrese el número de teléfono vinculado a [' +
                dataBankInfo.bank_name +
                ']！'
            "
          />
          <h5>
            <img src="@/assets/images/registTitleIcon.png" alt="" />
            Aviso importante
          </h5>
          <p>
            Por favor, ingrese el
            <strong>número de teléfono proporcionado al registrar</strong> su
            cuenta en <strong>[{{ dataBankInfo.bank_name }}]</strong>. Asegúrese
            de que el número sea correcto para garantizar que su cuenta reciba
            el monto del préstamo. Si ingresa otro número, no podrá recibir el
            monto del préstamo
          </p>
        </div>
        <!-- Tipo -->
        <div
          v-if="
            nowBankInfo.bankId !== '0101' && nowBankInfo.bankId !== '0102'
          "
        >
          <h3>Tipo</h3>
          <el-radio-group
            @change="changeBnakType"
            v-model="dataBankInfo.bank_card_type"
            size="mini"
          >
            <el-radio :label="1" border>Cuenta corriente</el-radio>
            <el-radio :label="2" border>Cuenta de ahorro</el-radio>
          </el-radio-group>
          <!-- bank_no -->
          <van-field
            v-model="dataBankInfo.bank_no"
            type="digit"
            maxlength="20"
            :placeholder="
              placehold
                ? 'Cuenta bancaria（' + placehold + 'dígitos）'
                : 'Cuenta bancaria'
            "
          />
          <!-- CCI -->
          <van-field
            v-model="dataBankInfo.ifsc_code"
            v-show="
              nowBankInfo.bankId &&
                nowBankInfo.bankId !== '0001' &&
                nowBankInfo.bankId !== '0002' &&
                nowBankInfo.bankId !== '0003' &&
                nowBankInfo.bankId !== '0004'
            "
            maxlength="20"
            type="digit"
            placeholder="CCI (opcional-20 dígitos)"
          />
        </div>
        <div class="submitBtn" @click="submitBtn(4)">
          Entregar
        </div>
      </van-collapse-item>
    </van-collapse>

    <!-- <div class="submitBtn" @click="submitBtn">
      Entregar
    </div> -->

    <!-- contactBox -->
    <!-- Información sobre nosotros -->
    <ContactOrAbout />

    <!-- choose Visible Box -->
    <van-popup v-model="showPicker" position="bottom">
      <!-- city -->
      <van-cascader
        confirm-button-text="confirmación"
        cancel-button-text="cancelación"
        v-if="statue == 0"
        v-model="cascaderValue"
        :field-names="fieldNames"
        :placeholder="selectTitle"
        :title="selectTitle"
        :options="chooseList"
        @close="showPicker = false"
        @finish="onConfirmCascader"
      />
      <!-- date -->
      <van-datetime-picker
        confirm-button-text="confirmación"
        cancel-button-text="cancelación"
        v-else-if="statue == 5"
        v-model="currentDate"
        type="date"
        :title="selectTitle"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
      <!-- bank -->
      <van-picker
        confirm-button-text="confirmación"
        cancel-button-text="cancelación"
        v-else-if="statue == 6"
        :title="selectTitle"
        show-toolbar
        value-key="bankName"
        :columns="bankList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
      <!-- orther -->
      <van-picker
        v-else
        confirm-button-text="confirmación"
        cancel-button-text="cancelación"
        :title="selectTitle"
        show-toolbar
        :columns="chooseList"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import {
  positionList,
  wageGradeList,
  getEduList,
  getContactTypeList,
  getContactTypeList2,
} from "../components/positionList";
import {
  getBankInfo,
  getUserInforList,
  editStep1Info,
  editStep2Info,
  editStep3Info,
  editStep4Info,
  OCRgetCardInfo,
  getCurrentInfo,
} from "../utils/api/h5page";
import ContactOrAbout from "../components/contactOrAbout.vue";

const SHOW_LIST = {
  1: wageGradeList,
  2: getEduList,
  3: getContactTypeList,
  4: getContactTypeList2,
};
export default {
  components: {
    Header,
    ContactOrAbout,
  },
  data() {
    return {
      registerTitle: {
        1: "¡Obtén tu préstamo fácilmente en solo cuatro pasos! Toda tu información estará protegida con cifrado.",
        2: "Por favor, complete cuidadosamente sus datos de contacto. Su información será protegida con cifrado.",
        3: "¡Ya podrás recibir el préstamo en seguida! Sube tu documento de identidad válido (frente) para pasar la revisión.",
        4: "¡Solo queda un paso! Complete con precisión los datos de su tarjeta bancaria para garantizar que reciba el préstamo exitosamente.",
      },
      loading1: false,
      loading2: false,
      loading3: false,
      loading4: false,
      showEmailList: false,
      emailList: [
        "@hotmail.com",
        "@yahoo.com",
        "@outlook.com",
        // "@Email.com",
        "@gmail.com",
      ],
      emailShowList: [],
      fieldNames: {
        text: "text",
        value: "text",
        children: "children",
      },
      minDate: new Date(1930, 0, 1),
      maxDate: new Date(2006, 11, 31),
      currentDate: new Date(1980, 0, 1),
      activeNames: "1",
      showPicker: false,
      statue: null,
      // 位置
      cascaderArray: [
        {
          title: "Departamento",
          id: 99,
        },
        {
          title: "Provincia",
          id: 98,
        },
        {
          title: "Distrito",
          id: 97,
        },
      ],
      cascaderValue: "",
      selectTitle: "",
      chooseList: [],
      bankList: [],
      fileList: [],
      stepStatue: 1,
      currentStep: 1001,
      // 提交个人信息
      dataInfoList: {
        job_type: 0,
        marital_status: 0,
        children_number: 0,
        resident_address: "",
        postal_code: "",
        salary_type: 0,
        salary_day: "",
        salary_day2: "",
        tfn: "",
        // 存在参数
        monthly_income: "",
        education: "",
        resident_state: "",
        resident_city: "",
        resident_district: "",
        email: "",
      },
      // 提交联系人信息
      dataContactInfo: {
        contact1: "",
        contact1_name: "",
        relationship1: "",
        contact2: "",
        contact2_name: "",
        relationship2: "",
      },
      // 提交身份信息
      dataIdCardInfo: {
        card_type: "1",
        dni: "",
        name1: "",
        surname1: "",
        surname2: "",
        gender: "M",
        birthday: "",
        pic_zheng_type: "0",
        pic_fan_type: "-1",
      },
      // 提交银行信息
      dataBankInfo: {
        bank_card_type: 2,
        bank_name: "",
        bank_no: "",
        ifsc_code: "",
        // mobile: "",
        // verifyCode: 0,
        // autoConfirm: 0,
      },
      // 展示文字信息
      dataContactInfoArray: [
        {
          relationshipText: "",
          id: 3,
        },
        {
          relationshipText: "",
          id: 4,
        },
      ],
      // 展示文字信息
      dataInfoText: {
        monthly_income: "",
        education: "",
      },
      birthdayText: "",
      placehold: "13",
      nowBankInfo: {
        bankId: "",
      },
    };
  },
  methods: {
    // confirm select
    onConfirm(val) {
      switch (this.statue) {
        case 1:
          this.dataInfoList.monthly_income = val.value;
          this.dataInfoText.monthly_income = val.text;
          break;
        case 2:
          this.dataInfoList.education = val.value;
          this.dataInfoText.education = val.text;
          break;
        case 3:
          if (this.dataContactInfo.relationship2 == 1 && val.value == 1) {
            return this.$Toast("La relación de contacto no se puede repetir");
          }
          this.dataContactInfo.relationship1 = val.value;
          break;
        case 4:
          if (val.value == 1 && this.dataContactInfo.relationship1 == 1) {
            return this.$Toast("La relación de contacto no se puede repetir");
          }
          this.dataContactInfo.relationship2 = val.value;
          break;
        case 5:
          this.dataIdCardInfo.birthday = val.getTime() / 1000;
          this.birthdayText = this.$setMoment(val.getTime(), 1, 1);
          break;
        case 6:
          if (this.dataBankInfo.bank_card_type == 1) {
            this.placehold = val.cuentaCorriente;
          } else if (this.dataBankInfo.bank_card_type == 2) {
            this.placehold = val.cuentaDeAhorro;
          }
          this.nowBankInfo = val;
          this.dataBankInfo.bank_name = val.bankName;
          this.break;
      }
      if (this.statue == 3 || this.statue == 4) {
        this.dataContactInfoArray.forEach((item) => {
          if (item.id == this.statue) {
            item.relationshipText = val.text;
          }
        });
      }
      this.showPicker = false;
    },

    getCurrentNum(jump) {
      getCurrentInfo().then(({ data }) => {
        this.currentStep = data.data.current_step;
        this.setStepStatue();
        if (jump) {
          if (data.data.current_step == 1110 || data.data.current_step == 105) {
            this.$router.push("/home");
          } else if (data.data.current_step == 1006) {
            this.$router.push("/faceIdentify");
          }
        }
      });
    },

    // choose City
    onConfirmCascader(val) {
      this.cascaderArray.forEach((item, index) => {
        item.text = val.selectedOptions[index].text;
      });
      // 州、市、区赋值
      this.dataInfoList.resident_state = val.selectedOptions[0].text;
      this.dataInfoList.resident_city = val.selectedOptions[1].text;
      this.dataInfoList.resident_district = val.selectedOptions[2].text;
      this.showPicker = false;
    },

    // open Select
    openChoosVisible(row, title) {
      this.showPicker = true;
      this.selectTitle = title;
      this.statue = row;
      this.chooseList = SHOW_LIST[row];
    },

    // open Cascader Select
    openChoosCascader() {
      this.showPicker = true;
      this.chooseList = positionList;
      this.statue = 0;
      this.selectTitle = "Elegir Departamento";
    },
    // open Date visible
    openDateVisible() {
      this.showPicker = true;
      this.statue = 5;
      this.selectTitle = "Fecha de nacimiento";
    },

    // open bank list
    openBankListVisible() {
      this.showPicker = true;
      this.statue = 6;
      this.selectTitle = "Información de la cuenta bancaria";
    },

    getBankList() {
      getBankInfo({ access_token: "281d367dfc572f0ebe3f718b103eb795" }).then(
        ({ data }) => {
          this.bankList = data.data.bankList;
        }
      );
    },

    // 单个提交信息
    submitBtn(row) {
      const {
        resident_state,
        resident_city,
        resident_district,
        monthly_income,
        education,
        email,
      } = this.dataInfoList;
      const {
        contact1,
        contact1_name,
        relationship1,
        contact2,
        contact2_name,
        relationship2,
      } = this.dataContactInfo;
      const {
        dni,
        name1,
        surname1,
        surname2,
        gender,
        birthday,
      } = this.dataIdCardInfo;
      const {
        bank_card_type,
        bank_name,
        bank_no,
        ifsc_code,
      } = this.dataBankInfo;
      switch (row) {
        case 1:
          if (!resident_state || !resident_city || !resident_district) {
            return this.$Toast("Por favor, elija su región");
          }
          if (!monthly_income) {
            return this.$Toast("Elegir ingreso mensual");
          }
          if (!education) {
            return this.$Toast("Por favor, elija un título académico");
          }
          if (!email) {
            return this.$Toast("Por favor, rellene el buzón.");
          }
          if (!this.$validateEmail(email)) {
            return this.$Toast("El formato del correo es incorrecto");
          }
          this.loading1 = true;
          editStep1Info(this.dataInfoList).then(({ data }) => {
            if (data.code == 0) {
              // this.stepStatue = 2;
              // this.activeNames = this.stepStatue.toString();
              this.getCurrentNum(1);
              this.$Toast("Envío exitoso");
            }
            this.loading1 = false;
          });
          break;
        case 2:
          if (!contact1 || !contact1_name || !relationship1) {
            return this.$Toast(
              "Por favor, complete la información del contacto 1."
            );
          }
          if (!contact2 || !contact2_name || !relationship2) {
            return this.$Toast(
              "Por favor, complete la información del contacto 2."
            );
          }
          this.loading2 = true;
          editStep2Info(this.dataContactInfo).then(({ data }) => {
            if (data.code == 0) {
              // this.stepStatue = 3;
              // this.activeNames = this.stepStatue.toString();
              this.getCurrentNum(1);
              this.$Toast("Envío exitoso");
            }
            this.loading2 = false;
          });
          break;
        case 3:
          if (!this.fileList.length) {
            return this.$Toast("Por favor, suba su tarjeta de identificación");
          }
          if (!dni || dni.length !== 8) {
            return this.$Toast(
              "Por favor, rellene el número DNI en el formato correcto."
            );
          }
          if (!name1) {
            return this.$Toast("Por favor, introduzca su nombre.");
          }
          if (!surname1 || !surname2) {
            return this.$Toast("Por favor, rellene el apellido.");
          }
          if (!gender) {
            return this.$Toast("Por favor, elija el sexo");
          }
          if (!birthday) {
            return this.$Toast("Por favor, elija la fecha de nacimiento");
          }
          this.loading3 = true;
          editStep3Info({
            ...this.dataIdCardInfo,
            gender: gender == "M" ? 1 : 0,
          }).then(({ data }) => {
            if (data.code == 0) {
              // this.stepStatue = 4;
              // this.activeNames = this.stepStatue.toString();
              this.getCurrentNum(1);
              this.$Toast("Envío exitoso");
            }
            this.loading3 = false;
          });
          break;
        case 4:
          if (!bank_name) {
            return this.$Toast("Por favor, elija el Banco");
          }
          if (!bank_card_type) {
            return this.$Toast("Por favor, elija el tipo de tarjeta bancaria");
          }
          if (!bank_no) {
            return this.$Toast(
              "Por favor, introduzca el número de tarjeta bancaria"
            );
          }
          if (
            ifsc_code.length !== 20 &&
            this.nowBankInfo.bankId !== "0001" &&
            this.nowBankInfo.bankId !== "0002" &&
            this.nowBankInfo.bankId !== "0003" &&
            this.nowBankInfo.bankId !== "0004" &&
            this.nowBankInfo.bankId !== "0101" &&
            this.nowBankInfo.bankId !== "0102"
          ) {
            return this.$Toast("CCI (opcional-20 dígitos)");
          }
          if (
            this.nowBankInfo.bankId == "0001" ||
            this.nowBankInfo.bankId == "0002" ||
            this.nowBankInfo.bankId == "0003" ||
            this.nowBankInfo.bankId == "0004" ||
            this.nowBankInfo.bankId == "0101" ||
            this.nowBankInfo.bankId == "0102"
          ) {
            this.dataBankInfo.ifsc_code = "";
          }
          this.loading4 = true;
          editStep4Info(this.dataBankInfo).then(({ data }) => {
            if (data.code == 0) {
              this.$Toast("Envío exitoso");
              this.getCurrentNum(1);
              this.getUserInfo(1);
            }
            this.loading4 = false;
          });
          break;
      }
      setTimeout(() => {
        // this.setStepStatue();
        this.getUserInfo();
      }, 100);
    },

    // OCR身份识别
    uploadSuccess(val) {
      this.$compressImg(val.content, val.file).then((data) => {
        val.file = data;
        console.log("[ val ] >", val);
        const formData = new FormData();
        formData.append("card_type", 1);
        formData.append("fs1_size", val.file.size);
        formData.append("fs1", val.file);
        formData.append("access_token", localStorage.getItem("token"));
        this.loading3 = true;
        OCRgetCardInfo(formData).then(({ data }) => {
          if (data.code == 0) {
            const {
              idNumber,
              name,
              fatherName,
              motherName,
              gender,
              birthday,
              resourceId,
            } = data.data;
            if (idNumber) {
              this.dataIdCardInfo.dni = idNumber;
            }
            if (name) {
              this.dataIdCardInfo.name1 = name;
            }
            if (fatherName) {
              this.dataIdCardInfo.surname1 = fatherName;
            }
            if (motherName) {
              this.dataIdCardInfo.surname2 = motherName;
            }
            if (gender) {
              this.dataIdCardInfo.gender = gender == "M" ? "M" : "W";
            }

            if (birthday) {
              this.birthdayText = birthday;
              this.dataIdCardInfo.birthday = this.$setTimeStr(birthday) / 1000;
            }
            console.log(data.data, resourceId.toString());
            this.dataIdCardInfo.id_photo_id = resourceId.toString();
            this.dataIdCardInfo.ocr_json = data.data;
          } else {
            // this.$Toast(data.message);
            this.fileList = [];
          }
          this.loading3 = false;
        });
      });
    },

    // 获取用户信息
    getUserInfo(row) {
      getUserInforList().then(({ data }) => {
        // info 1 数据回显
        if (data.data.personal_info.resident_state) {
          this.dataInfoList = data.data.personal_info;
          this.cascaderArray[0].text = this.dataInfoList.resident_state;
          this.cascaderArray[1].text = this.dataInfoList.resident_city;
          this.cascaderArray[2].text = this.dataInfoList.resident_district;
          wageGradeList.map((item) => {
            if (item.value == this.dataInfoList.monthly_income) {
              this.dataInfoText.monthly_income = item.text;
            }
          });

          getEduList.map((item) => {
            if (item.value == this.dataInfoList.education) {
              this.dataInfoText.education = item.text;
            }
          });
        }
        // info 2 数据回显
        if (data.data.contact_info.contact1) {
          this.dataContactInfo = data.data.contact_info;
          getContactTypeList2.map((item) => {
            if (item.value == this.dataContactInfo.relationship1) {
              this.dataContactInfoArray[0].relationshipText = item.text;
            }
            if (item.value == this.dataContactInfo.relationship2) {
              this.dataContactInfoArray[1].relationshipText = item.text;
            }
          });
        }
        // info 3 数据回显
        if (data.data.identity_info.dni) {
          this.dataIdCardInfo = {
            ...data.data.identity_info,
            gender: data.data.identity_info.gender == 0 ? "W" : "M",
          };
          this.birthdayText = this.$setMoment(
            data.data.identity_info.birthday * 1000,
            1,
            1
          );
          this.fileList = [{ url: data.data.identity_info.id_photo }];
        }

        // info 4 数据回显
        if (data.data.card_info.bank_no) {
          this.dataBankInfo = { ...data.data.card_info };
          this.bankList.map((item) => {
            if (item.bankName == this.dataBankInfo.bank_name) {
              this.nowBankInfo = item;
              if (this.dataBankInfo.bank_card_type == 1) {
                this.placehold = item.cuentaCorriente;
              } else if (this.dataBankInfo.bank_card_type == 2) {
                this.placehold = item.cuentaDeAhorro;
              }
            }
          });
        }

        if (
          row &&
          JSON.parse(localStorage.getItem("userInfo")).is_reloan == 0 &&
          data.data.current_step == 1006
        ) {
          this.$router.push("/faceIdentify");
        }
      });
    },

    setStepStatue() {
      switch (this.currentStep) {
        case 1001:
          this.stepStatue = 1;
          this.activeNames = "1";
          break;
        case 1004:
          this.stepStatue = 1;
          this.activeNames = "1";
          break;
        case 1002:
          this.stepStatue = 2;
          this.activeNames = "2";
          break;
        case 1005:
          this.stepStatue = 3;
          this.activeNames = "3";
          break;
        case 1010:
          this.stepStatue = 4;
          this.activeNames = "4";
          break;
        case 1006:
          this.stepStatue = 4;
          this.activeNames = "4";
          break;
        case 1110:
          this.stepStatue = 4;
          this.activeNames = "4";
          break;
        case 105:
          this.stepStatue = 4;
          this.activeNames = "4";
          break;
      }
    },

    // 更改银行类型
    changeBnakType() {
      if (this.dataBankInfo.bank_card_type == 1) {
        this.placehold = this.nowBankInfo.cuentaCorriente;
      } else if (this.dataBankInfo.bank_card_type == 2) {
        this.placehold = this.nowBankInfo.cuentaDeAhorro;
      }
    },
    // 邮箱匹配 补全
    changeEmail(val) {
      // if (val.includes("ww") && !val.includes("@")) {
      //   this.emailShowList = this.emailList.map((item) => {
      //     return (item = val + item);
      //   });
      // } else
      if (
        val.includes("@") &&
        !val.includes(".com") &&
        !val.includes(".co") &&
        !val.includes(".c")
      ) {
        this.emailShowList = this.emailList.map((item) => {
          if (val.includes("@") && item.slice(item.indexOf("@") + 1)) {
            if (
              item
                .slice(item.indexOf("@") + 1, -4)
                .includes(val.slice(val.indexOf("@") + 1))
            ) {
              return (item =
                val.slice(0, val.indexOf("@") + 1) +
                item.slice(item.indexOf("@") + 1));
            } else {
              return "";
            }
          }
        });
      } else if (
        val.includes(".com") ||
        val.includes(".co") ||
        val.includes(".c")
      ) {
        this.emailShowList = [];
      } else {
        this.emailShowList = this.emailList.map((item) => {
          return (item = val + item);
        });
      }
      // 数组判空
      let arrState = this.emailShowList.every((item) => item == "");
      if (this.emailShowList.length && !arrState) {
        this.showEmailList = true;
      } else {
        this.showEmailList = false;
      }
    },

    chooseEmail(val) {
      console.log("[ val ] >", val);
      this.dataInfoList.email = val;
    },

    closeSelect() {
      setTimeout(() => {
        this.showEmailList = false;
      }, 50);
    },
  },

  mounted() {
    this.getBankList();
    this.getUserInfo();
    this.getCurrentNum();
    const disabledBtn2 = document.querySelector("#disBtn2");
    const disabledBtn3 = document.querySelector("#disBtn3");
    const disabledBtn4 = document.querySelector("#disBtn4");
    disabledBtn2.addEventListener("click", () => {
      if (this.stepStatue < 2) {
        return this.$Toast(
          "Primero complete la información en el paso anterior."
        );
      }
    });
    disabledBtn3.addEventListener("click", () => {
      if (this.stepStatue < 3) {
        return this.$Toast(
          "Primero complete la información en el paso anterior."
        );
      }
    });
    disabledBtn4.addEventListener("click", () => {
      if (this.stepStatue < 4) {
        return this.$Toast(
          "Primero complete la información en el paso anterior."
        );
      }
    });
  },

  watch: {
    // "dataBankInfo.bank_name"() {
    //   this.dataBankInfo.bank_no = "";
    //   this.dataBankInfo.ifsc_code = "";
    // },
  },
};
</script>

<style lang="scss" scoped>
.bigBox {
  padding: 0 0.2rem 0.2rem;
  background-color: #f5f5f5;
}
.bgcBox {
  position: absolute;
  left: 0;
  top: 0;
  background: linear-gradient(180deg, #fb5555 0%, #f5f5f5 100%);
  width: 100%;
  height: 5.37rem;
}

h5 {
  position: relative;
  z-index: 10;
  font-family: Roboto, Roboto;
  font-weight: 700;
  font-size: 0.26rem;
  color: #ffffff;
  margin: 0.3rem 0 0.53rem;
}

.stepBox {
  position: relative;
  z-index: 10;
  margin-bottom: 0.34rem;
  img {
    display: block;
    width: 100%;
  }
}

.van-collapse {
  border-radius: 0.2rem;
}
.van-collapse-item {
  border-radius: 0.2rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
}
/deep/ .van-cell__title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 700;
  font-size: 0.32rem;
  color: #333333;
}
/deep/ .van-cell {
  border-top-right-radius: 0.2rem;
  border-top-left-radius: 0.2rem;
  padding: 0.28rem 0.2rem;
  line-height: normal;
  align-items: center;
}

/deep/ .van-field__control {
  font-size: 0.23rem;
}

/deep/ .van-collapse-item__wrapper {
  border-bottom-right-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
  margin-top: -0.03rem;
}

/deep/ .van-icon-arrow:before {
  content: "\e702";
}

/deep/ .van-cell__right-icon {
  line-height: 0;
  height: max-content;
  color: #333;
}
/deep/ .van-collapse-item__title--expanded::after {
  display: none;
}

/deep/ .van-collapse-item__content {
  padding: 0.1rem 0.2rem 0.4rem;
}

.chooseListBox {
  // width: 6.4rem;
  height: 0.7rem;
  border-radius: 0.1rem;
  border: 0.02rem solid #ececec;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0.2rem;
  margin-bottom: 0.2rem;
  color: #b8b9ba;
  font-size: 0.23rem;
  .title {
    width: 47%;
  }
  .content {
    width: 55%;
    color: #333333;
  }
  i {
    color: #333333;
  }
}

.concatBox {
  h5 {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.28rem;
    color: #333333;
    margin: 0 0 0.2rem;
  }
}
.van-cell {
  height: 0.7rem;
  border: 0.02rem solid #ececec;
  border-radius: 0.1rem;
  padding: 0 0 0 0.2rem;
  margin-bottom: 0.2rem;
  display: flex;
}

.submitBtn {
  width: 5.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
  background: #c90000;
  border-radius: 0.4rem;
  margin: 0.4rem auto 0.14rem;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 0.32rem;
  color: #ffffff;
  text-align: center;
}

.van-uploader {
  display: block;
  padding-top: 0.28rem;
  /deep/ .van-uploader__wrapper {
    justify-content: center;
  }
  img {
    width: 4.12rem;
    height: 2.76rem;
  }
  /deep/ .van-image {
    width: 4.12rem;
    height: 2.76rem;
    border-radius: 0.1rem;
  }
}
.uploadText {
  font-family: Roboto, Roboto;
  font-weight: 700;
  font-size: 0.26rem;
  color: #333333;
  text-align: center;
  margin: 0.17rem 0 0.3rem;
}

h3 {
  font-family: Roboto, Roboto;
  font-weight: 700;
  font-size: 0.26rem;
  color: #333333;
  margin: 0.3rem 0 0.2rem;
}
.el-radio-group {
  display: flex;
}
.el-radio--mini.is-bordered {
  width: 2.9rem;
  height: 0.7rem;
  border-radius: 0.1rem;
  border: 0.02rem solid #ececec;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.2rem;
}
/deep/ .el-radio {
  font-size: 0;
  margin-bottom: 0.2rem;
}
/deep/ .el-radio--mini.is-bordered .el-radio__inner {
  width: 0.3rem;
  height: 0.3rem;
  border: 0.01rem solid #999999;
}
/deep/ .el-radio__input.is-checked .el-radio__inner {
  border-color: #c90000;
  background: #fff;
}
/deep/ .el-radio__inner::after {
  width: 0.14rem;
  height: 0.15rem;
  background-color: #c90000;
}
/deep/ .el-radio.is-bordered.is-checked {
  border-color: #c90000;
}
/deep/ .el-radio--mini.is-bordered .el-radio__label {
  font-family: Roboto, Roboto;
  font-weight: 400;
  font-size: 0.26rem;
  color: #666666;
}
.emailSelet {
  position: relative;
  .selectBox {
    position: absolute;
    top: 0.8rem;
    left: 0;
    width: 100%;
    overflow: hidden;
    transition: all 0.4s;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    overflow: auto;
    li {
      padding: 0.15rem;
      font-size: 0.23rem;
    }
  }
}
/deep/ .van-field__label {
  width: 43%;
  font-weight: 400;
  color: #b8b9ba;
  font-size: 0.23rem;
  margin-right: 0;
}

.bankTitleBox {
  h5 {
    display: flex;
    align-items: center;
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.24rem;
    color: #333333;
    margin: 0 0 0.07rem;
    img {
      width: 0.26rem;
      height: 0.26rem;
      margin-right: 0.06rem;
    }
  }
  p {
    font-family: Roboto, Roboto;
    font-weight: 400;
    font-size: 0.2rem;
    color: #666666;
    line-height: 0.24rem;
    strong {
      color: #000;
    }
  }
}
</style>
